import flatten from 'lodash/flatten';
import urlJoin from '@framework/url/helpers/urlJoin';
import domain from '@framework/config/domain';
import config from '@openmarket/config';
import isServer from '@framework/router/Next/isServer';
import shouldUseInternalNetwork from '@framework/router/Next/shouldUseInternalNetwork';

export default {
  getUrl(uris: Array<string> | string = []) {
    if (!Array.isArray(uris)) {
      uris = [uris];
    }
    uris = flatten(uris).filter((uri) => !!uri);
    return urlJoin(`${ domain.protocol }//${ config.hostname }`, ...uris);
  },

  getRpcUrl(): string {
    if (shouldUseInternalNetwork()) {
      return this.getInternalRpcUrl();
    }

    return !isServer()
      ? `${ domain.protocol }//${ window.location.host }/proxy/api/open-market/rpc`
      : `${ domain.protocol }//${ domain.apiDomain }/open-market/rpc`;
  },

  getInternalRpcUrl(): string {
    return `${ config.api.internal }/rpc`;
  },
};
